(function(){
'use strict';

/*
================================================================
KINFOLK LIT - SHARED AUTHOR PROFILE MODAL
2026.09.21 v3
================================================================
- Preserves confirmed v2 Catalog -> Author behavior.
- Preserves confirmed v2 fast return.
- Author Profile Literary Interests have been removed completely.
- Author track icons come ONLY from canonical Books.
- KLFBookDiscovery returns DOM records, not JavaScript Book objects.
- Canonical tracks are read from record.dataset.trackNames.
================================================================
*/

if (window.KLFCanonicalAuthorModalReady) return;
window.KLFCanonicalAuthorModalReady = true;

function clean(value) {
  return String(value || '').trim();
}

function esc(value) {
  if (
    window.CSS &&
    typeof window.CSS.escape === 'function'
  ) {
    return window.CSS.escape(
      String(value || '')
    );
  }

  return String(value || '')
    .replace(/["\\]/g, '\\$&');
}

function splitValues(value) {
  return String(value || '')
    .split('||')
    .map(function(item){
      return clean(item);
    })
    .filter(Boolean);
}

var TRACKS = {
  'Black to the Future': {
    color:'#24315C',
    icon:'https://cdn.shopify.com/s/files/1/0768/0566/8909/files/scifi_fantasy.svg?v=1788093254'
  },

  'Coming in Hot, Coming of Age': {
    color:'#BC69AC',
    icon:'https://cdn.shopify.com/s/files/1/0768/0566/8909/files/ya.svg?v=1788093254'
  },

  'Don’t Go in There!': {
    color:'#9C3B3B',
    icon:'https://cdn.shopify.com/s/files/1/0768/0566/8909/files/thriller_mystery.svg?v=1788093255'
  },

  "Don't Go in There!": {
    color:'#9C3B3B',
    icon:'https://cdn.shopify.com/s/files/1/0768/0566/8909/files/thriller_mystery.svg?v=1788093255'
  },

  'Drawn + Written': {
    color:'#5F86A6',
    icon:'https://cdn.shopify.com/s/files/1/0768/0566/8909/files/thought_bubble.svg?v=1788093254'
  },

  'Love Jones & Situationships': {
    color:'#C75A4A',
    icon:'https://cdn.shopify.com/s/files/1/0768/0566/8909/files/romance.svg?v=1788093254'
  },

  'Our Stories, Our Terms': {
    color:'#2F6E8D',
    icon:'https://cdn.shopify.com/s/files/1/0768/0566/8909/files/literary_fiction.svg?v=1788093254'
  },

  'Real Life | Real Talk': {
    color:'#418066',
    icon:'https://cdn.shopify.com/s/files/1/0768/0566/8909/files/podcast_nonfiction.svg?v=1788093254'
  }
};

var TRACK_ORDER = [
  'Black to the Future',
  'Coming in Hot, Coming of Age',
  'Don’t Go in There!',
  'Drawn + Written',
  'Love Jones & Situationships',
  'Our Stories, Our Terms',
  'Real Life | Real Talk'
];

function normalizeTrack(value) {
  var track = clean(value);

  if (
    track ===
    'Real Life, Real Talk'
  ) {
    return 'Real Life | Real Talk';
  }

  if (
    track ===
    "Don't Go in There!"
  ) {
    return 'Don’t Go in There!';
  }

  return track;
}

function hydrateTrackIcons(scope) {
  (scope || document)
    .querySelectorAll(
      '[data-track-icon]'
    )
    .forEach(function(node){

      if (
        node.dataset.trackHydrated ===
        'true'
      ) {
        return;
      }

      var trackName =
        normalizeTrack(
          node.dataset.trackIcon
        );

      var config =
        TRACKS[trackName];

      if (!config) {
        return;
      }

      node.innerHTML = '';

      var mask =
        document.createElement(
          'span'
        );

      mask.className =
        'author-profile-modal__track-mask';

      mask.style.setProperty(
        '--track-color',
        config.color
      );

      mask.style.setProperty(
        '--track-mask',
        'url("' +
        config.icon +
        '")'
      );

      node.appendChild(
        mask
      );

      node.dataset.trackHydrated =
        'true';
    });
}

/*
================================================================
CANONICAL AUTHOR TRACKS
================================================================
KLFBookDiscovery.getBooksForAuthorProfile() returns the hidden
<article data-klf-book-record> DOM records.

Each record stores Book.kinfolk_lit_tracks in:
record.dataset.trackNames

Multiple tracks are separated by ||.
================================================================
*/

function tracksFromBookRecords(records) {
  var found = Object.create(null);

  (Array.isArray(records) ? records : [])
    .forEach(function(record){

      if (!record || !record.dataset) {
        return;
      }

      splitValues(
        record.dataset.trackNames
      )
        .forEach(function(rawTrack){

          var track =
            normalizeTrack(
              rawTrack
            );

          if (
            !track ||
            !TRACKS[track]
          ) {
            return;
          }

          found[track] = true;
        });
    });

  /*
   * Keep icon order stable across the website instead of allowing
   * Book ordering to determine visual track order.
   */
  return TRACK_ORDER.filter(
    function(track){
      return Boolean(
        found[track]
      );
    }
  );
}

function trackContainersForProfile(
  profileId
) {
  profileId =
    clean(profileId);

  if (!profileId) {
    return [];
  }

  return Array.from(
    document.querySelectorAll(
      '[data-author-track-container][data-author-profile-id="' +
      esc(profileId) +
      '"]'
    )
  );
}

function renderTracksForProfile(
  profileId,
  tracks
) {
  var containers =
    trackContainersForProfile(
      profileId
    );

  containers.forEach(
    function(container){

      container.innerHTML = '';

      if (!tracks.length) {
        container.hidden = true;
        return;
      }

      tracks.forEach(
        function(track){

          var icon =
            document.createElement(
              'span'
            );

          icon.className =
            'author-profile-modal__track-icon ' +
            'author-profile-modal__track-icon--large';

          icon.dataset.trackIcon =
            track;

          icon.title =
            track;

          icon.setAttribute(
            'aria-label',
            track
          );

          container.appendChild(
            icon
          );
        }
      );

      container.hidden = false;

      hydrateTrackIcons(
        container
      );
    }
  );
}

function applyCanonicalTracks(
  profileId
) {
  profileId =
    clean(profileId);

  if (
    !profileId ||
    !window.KLFBookDiscovery ||
    typeof window.KLFBookDiscovery.getBooksForAuthorProfile !==
      'function'
  ) {
    return;
  }

  var records =
    window.KLFBookDiscovery
      .getBooksForAuthorProfile(
        profileId
      );

  var tracks =
    tracksFromBookRecords(
      records
    );

  renderTracksForProfile(
    profileId,
    tracks
  );
}

function loadCanonicalTracksForProfile(
  profileId
) {
  profileId =
    clean(profileId);

  if (!profileId) {
    return;
  }

  if (
    !window.KLFBookDiscovery ||
    typeof window.KLFBookDiscovery.getBooksForAuthorProfile !==
      'function'
  ) {
    return;
  }

  /*
   * Use records already available on the current Liquid page
   * immediately.
   */
  applyCanonicalTracks(
    profileId
  );

  /*
   * Then load the complete canonical Books database.
   *
   * Book Discovery owns its own loadPromise, so repeated calls from
   * multiple Author Profiles do not create duplicate pagination loads.
   */
  if (
    typeof window.KLFBookDiscovery.load ===
      'function'
  ) {
    try {
      var result =
        window.KLFBookDiscovery.load();

      if (
        result &&
        typeof result.then ===
          'function'
      ) {
        result
          .then(function(){
            applyCanonicalTracks(
              profileId
            );
          })
          .catch(function(){});
      }
    } catch (error) {}
  }
}

/*
================================================================
AUTHOR MODAL CORE
================================================================
*/

function globalize(modal) {
  if (!modal) {
    return null;
  }

  if (
    modal.parentElement !==
    document.body
  ) {
    document.body.appendChild(
      modal
    );
  }

  modal.dataset.kinfolkGlobalModal =
    'true';

  return modal;
}

function allAuthorModals() {
  return Array.from(
    document.querySelectorAll(
      '[data-author-modal]'
    )
  );
}

function globalizeAll() {
  allAuthorModals()
    .forEach(
      globalize
    );
}

function identityFor(
  modal,
  profileId
) {
  if (
    !modal ||
    !profileId
  ) {
    return null;
  }

  return modal.querySelector(
    '[data-author-identity][data-author-profile-id="' +
    esc(profileId) +
    '"]'
  );
}

function modalByProfile(
  profileId
) {
  profileId =
    clean(profileId);

  if (!profileId) {
    return null;
  }

  globalizeAll();

  return (
    allAuthorModals()
      .find(
        function(modal){
          return Boolean(
            identityFor(
              modal,
              profileId
            )
          );
        }
      ) ||
    null
  );
}

function modalByParticipant(
  participantId
) {
  participantId =
    clean(participantId);

  if (!participantId) {
    return null;
  }

  globalizeAll();

  return (
    allAuthorModals()
      .find(
        function(modal){
          return (
            clean(
              modal.dataset.participantId
            ) ===
            participantId
          );
        }
      ) ||
    null
  );
}

function setIdentity(
  modal,
  profileId,
  suppressNotification
) {
  if (!modal) {
    return false;
  }

  profileId =
    clean(profileId) ||
    clean(
      modal.dataset.defaultAuthorProfileId
    );

  var target =
    identityFor(
      modal,
      profileId
    );

  if (!target) {
    return false;
  }

  var alreadyActive =
    clean(
      modal.dataset.activeAuthorProfileId
    ) ===
      profileId &&
    !target.hidden &&
    target.classList.contains(
      'is-active'
    );

  if (alreadyActive) {
    loadCanonicalTracksForProfile(
      profileId
    );

    return true;
  }

  modal
    .querySelectorAll(
      '[data-author-identity]'
    )
    .forEach(
      function(identity){

        var active =
          identity ===
          target;

        identity.hidden =
          !active;

        identity.classList.toggle(
          'is-active',
          active
        );
      }
    );

  modal.dataset.activeAuthorProfileId =
    profileId;

  loadCanonicalTracksForProfile(
    profileId
  );

  if (
    !suppressNotification &&
    window.KLFProfileModal &&
    typeof window.KLFProfileModal.authorIdentityChanged ===
      'function'
  ) {
    window.KLFProfileModal.authorIdentityChanged({
      participantId:
        clean(
          modal.dataset.participantId
        ),
      profileId:
        profileId
    });
  }

  return true;
}

/*
================================================================
FAST SHARED-LAYER RETURN
Preserved from confirmed working v2.
================================================================
*/

function closeOtherSharedLayers(
  authorModal
) {
  /*
   * Only layers that are currently showing need closing. Matching every
   * modal on the page (hundreds on Family Reunion) made each tap slower.
   */
  document
    .querySelectorAll(
      '[data-author-modal].is-open,' +
      '[data-influencer-modal].is-open,' +
      '[data-influencer-modal]:not([hidden]),' +
      '[data-professional-modal].is-open,' +
      '[data-professional-modal]:not([hidden]),' +
      '[data-profile-modal].is-open,' +
      '[data-catalog-modal].is-open,' +
      '[data-klf-shared-catalog].is-open,' +
      '[data-klf-book-modal]:not([hidden]),' +
      '[data-book-modal]:not([hidden])'
    )
    .forEach(
      function(layer){

        if (
          !layer ||
          layer ===
            authorModal
        ) {
          return;
        }

        if (
          layer.matches(
            '[data-author-modal],' +
            '[data-profile-modal],' +
            '[data-catalog-modal],' +
            '[data-klf-shared-catalog]'
          )
        ) {
          layer.classList.remove(
            'is-open'
          );

          layer.setAttribute(
            'aria-hidden',
            'true'
          );
        }

        if (
          layer.matches(
            '[data-klf-book-modal],' +
            '[data-book-modal]'
          )
        ) {
          layer.hidden =
            true;

          layer.setAttribute(
            'aria-hidden',
            'true'
          );
        }

        if (
          layer.matches(
            '[data-influencer-modal],' +
            '[data-professional-modal]'
          )
        ) {
          layer.classList.remove(
            'is-open'
          );

          layer.hidden =
            true;

          layer.setAttribute(
            'aria-hidden',
            'true'
          );
        }
      }
    );
}

function anotherSharedLayerIsOpen() {
  return Boolean(
    document.querySelector(
      '[data-author-modal].is-open,' +
      '[data-influencer-modal]:not([hidden]),' +
      '[data-professional-modal]:not([hidden]),' +
      '[data-catalog-modal].is-open,' +
      '[data-klf-shared-catalog].is-open,' +
      '[data-klf-book-modal]:not([hidden]),' +
      '[data-book-modal]:not([hidden])'
    )
  );
}

function syncBodyLock() {
  document.body.classList.toggle(
    'kinfolk-modal-open',
    anotherSharedLayerIsOpen()
  );
}

function openModal(
  modal,
  profileId
) {
  if (
    !modal ||
    modal.dataset.listOnSite ===
      'false'
  ) {
    return false;
  }

  globalize(
    modal
  );

  var requested =
    clean(profileId) ||
    clean(
      modal.dataset.defaultAuthorProfileId
    );

  var requestedIdentity =
    identityFor(
      modal,
      requested
    );

  if (!requestedIdentity) {
    return false;
  }

  var alreadyActive =
    clean(
      modal.dataset.activeAuthorProfileId
    ) ===
      requested &&
    !requestedIdentity.hidden &&
    requestedIdentity.classList.contains(
      'is-active'
    );

  /*
   * Preserve confirmed v2 behavior:
   * hide Catalog / outgoing shared layer immediately.
   */
  closeOtherSharedLayers(
    modal
  );

  /*
   * Present Author immediately.
   */
  modal.classList.add(
    'is-open'
  );

  modal.setAttribute(
    'aria-hidden',
    'false'
  );

  document.body.classList.add(
    'kinfolk-modal-open'
  );

  if (!alreadyActive) {
    setIdentity(
      modal,
      requested,
      false
    );
  } else {
    loadCanonicalTracksForProfile(
      requested
    );
  }

  var dialog =
    modal.querySelector(
      '.author-profile-modal__dialog'
    );

  if (dialog) {
    dialog.scrollTop =
      0;

    try {
      dialog.focus({
        preventScroll:true
      });
    } catch (error) {
      dialog.focus();
    }
  }

  return true;
}

function closeModal(
  modal
) {
  if (!modal) {
    return false;
  }

  modal.classList.remove(
    'is-open'
  );

  modal.setAttribute(
    'aria-hidden',
    'true'
  );

  syncBodyLock();

  return true;
}

/*
================================================================
PUBLIC AUTHOR API
Used by Profile Host, Catalog and Book Modal.
================================================================
*/

window.KLFAuthorModalOpen =
  function(
    modalOrId,
    trigger,
    explicitProfileId
  ) {
    globalizeAll();

    var modal =
      typeof modalOrId ===
        'string'
        ? document.getElementById(
            modalOrId
          )
        : modalOrId;

    if (!modal) {
      return false;
    }

    var requested =
      clean(
        explicitProfileId
      );

    if (
      !requested &&
      trigger
    ) {
      requested =
        clean(
          trigger.getAttribute(
            'data-author-profile-id'
          ) ||
          trigger.getAttribute(
            'data-profile-id'
          )
        );
    }

    if (!requested) {
      requested =
        clean(
          modal.dataset.defaultAuthorProfileId
        );
    }

    return openModal(
      modal,
      requested
    );
  };

window.KLFAuthorModalOpenByAuthorProfile =
  function(
    profileId
  ) {
    profileId =
      clean(
        profileId
      );

    if (!profileId) {
      return false;
    }

    var modal =
      modalByProfile(
        profileId
      );

    if (!modal) {
      return false;
    }

    return openModal(
      modal,
      profileId
    );
  };

window.KLFAuthorModalOpenByParticipant =
  function(
    participantId,
    trigger
  ) {
    var modal =
      modalByParticipant(
        participantId
      );

    if (!modal) {
      return false;
    }

    var requested =
      trigger
        ? clean(
            trigger.getAttribute(
              'data-author-profile-id'
            ) ||
            trigger.getAttribute(
              'data-profile-id'
            )
          )
        : '';

    if (
      !requested ||
      !identityFor(
        modal,
        requested
      )
    ) {
      requested =
        clean(
          modal.dataset.activeAuthorProfileId
        ) ||
        clean(
          modal.dataset.defaultAuthorProfileId
        );
    }

    return openModal(
      modal,
      requested
    );
  };

window.KLFAuthorModalClose =
  function(
    modalOrId
  ) {
    var modal =
      typeof modalOrId ===
        'string'
        ? document.getElementById(
            modalOrId
          )
        : modalOrId;

    return closeModal(
      modal
    );
  };

/*
================================================================
AUTHOR-INTERNAL CONTROLS
================================================================
*/

document.addEventListener(
  'click',
  function(event){

    var alias =
      event.target.closest(
        '[data-author-identity-switch]'
      );

    if (alias) {
      var aliasModal =
        alias.closest(
          '[data-author-modal]'
        );

      if (!aliasModal) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      setIdentity(
        aliasModal,
        alias.getAttribute(
          'data-author-identity-switch'
        ),
        false
      );

      return;
    }

    var closeControl =
      event.target.closest(
        '[data-author-modal-close]'
      );

    if (closeControl) {
      var modal =
        closeControl.closest(
          '[data-author-modal]'
        );

      if (!modal) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      closeModal(
        modal
      );
    }
  }
);

document.addEventListener(
  'keydown',
  function(event){

    if (
      event.key !==
      'Escape'
    ) {
      return;
    }

    var modal =
      document.querySelector(
        '[data-author-modal].is-open'
      );

    if (!modal) {
      return;
    }

    event.preventDefault();

    closeModal(
      modal
    );
  }
);

/*
 * PERFORMANCE (2026.10.18)
 * Track icons live inside Author modals, which are hidden until opened.
 * They used to be computed for every Author on the page at load, then
 * again for every Author when Book Discovery finished (each pass scanning
 * every Book). On pages with hundreds of Authors that blocked the main
 * thread for seconds and made taps feel unresponsive.
 *
 * Now icons are computed only for the identity being shown: on open, on
 * pen-name switch, and once more if Book Discovery finishes while that
 * Author modal is open.
 */
function activeOpenAuthorProfileIds() {
  return Array.from(
    document.querySelectorAll(
      '[data-author-modal].is-open'
    )
  )
    .map(function(modal){
      return clean(
        modal.dataset.activeAuthorProfileId ||
        modal.dataset.defaultAuthorProfileId
      );
    })
    .filter(Boolean);
}

document.addEventListener(
  'klf:book-discovery-ready',
  function(){
    activeOpenAuthorProfileIds()
      .forEach(
        function(profileId){
          applyCanonicalTracks(
            profileId
          );
        }
      );
  }
);

/*
================================================================
CATALOG PEN-NAME SWITCHER (2026.10.18)
================================================================
When the shared catalog shows an Author Profile whose author writes
under other names, an "Also writes as" ribbon appears under the intro.
Each name is a standard [data-catalog-open] trigger, so the shared
catalog itself opens that identity's catalog and its "Back to" button
returns to that identity. Catalog code is not modified.
================================================================
*/

function catalogIdentityNameOf(identity) {
  var nameNode =
    identity.querySelector(
      '.author-profile-modal__name'
    );

  return clean(
    nameNode
      ? nameNode.textContent
      : ''
  )
    .replace(/‑/g, '-')
    .replace(/\s+/g, ' ');
}

function catalogIdentitiesFor(
  authorProfileId
) {
  var identity =
    authorProfileId
      ? document.querySelector(
          '[data-author-modal] [data-author-identity][data-author-profile-id="' +
          esc(authorProfileId) +
          '"]'
        )
      : null;

  var modal =
    identity
      ? identity.closest('[data-author-modal]')
      : null;

  if (!modal) {
    return {
      participantId: '',
      others: []
    };
  }

  var seen =
    Object.create(null);

  seen[authorProfileId] =
    true;

  var others =
    Array.from(
      modal.querySelectorAll(
        '[data-author-identity][data-author-profile-id]'
      )
    )
      .map(function(node){
        return {
          id: clean(node.dataset.authorProfileId),
          name: catalogIdentityNameOf(node)
        };
      })
      .filter(function(item){
        if (
          !item.id ||
          !item.name ||
          seen[item.id]
        ) {
          return false;
        }

        seen[item.id] =
          true;

        return true;
      });

  return {
    participantId:
      clean(modal.dataset.participantId),
    others:
      others
  };
}

function catalogIdentityBar(catalog) {
  var bar =
    catalog.querySelector(
      '[data-catalog-identities]'
    );

  if (bar) {
    return bar;
  }

  var intro =
    catalog.querySelector(
      '.kinfolk-catalog__intro'
    );

  if (!intro) {
    return null;
  }

  bar =
    document.createElement('div');

  bar.className =
    'kinfolk-catalog__identities';

  bar.setAttribute(
    'data-catalog-identities',
    ''
  );

  bar.hidden =
    true;

  bar.innerHTML =
    '<span class="kinfolk-catalog__identities-ribbon">' +
      '<span class="kinfolk-catalog__identities-label">Also writes as</span>' +
      '<span class="kinfolk-catalog__identities-names" data-catalog-identity-list></span>' +
    '</span>';

  intro.insertAdjacentElement(
    'afterend',
    bar
  );

  return bar;
}

function renderCatalogIdentities(catalog) {
  var bar =
    catalogIdentityBar(catalog);

  if (!bar) {
    return;
  }

  var list =
    bar.querySelector(
      '[data-catalog-identity-list]'
    );

  var authorProfileId =
    clean(
      catalog.dataset.catalogAuthorProfileId
    );

  var found =
    catalogIdentitiesFor(
      authorProfileId
    );

  var participantId =
    clean(catalog.dataset.catalogParticipantId) ||
    found.participantId;

  var key =
    authorProfileId +
    '|' +
    found.others
      .map(function(item){ return item.id; })
      .join(',');

  if (bar.dataset.renderedFor === key) {
    return;
  }

  bar.dataset.renderedFor =
    key;

  list.innerHTML =
    '';

  found.others.forEach(
    function(item, index){

      if (index > 0) {
        var dot =
          document.createElement('span');

        dot.setAttribute(
          'aria-hidden',
          'true'
        );

        dot.textContent =
          ' • ';

        list.appendChild(dot);
      }

      var button =
        document.createElement('button');

      button.type =
        'button';

      button.className =
        'kinfolk-catalog__identity-switch';

      button.setAttribute(
        'data-catalog-open',
        ''
      );

      button.dataset.catalogAuthorProfileId =
        item.id;

      button.dataset.catalogParticipantId =
        participantId;

      button.dataset.catalogParticipantName =
        item.name;

      button.textContent =
        item.name.replace(/-/g, '‑');

      button.setAttribute(
        'aria-label',
        'View books by ' + item.name
      );

      list.appendChild(button);
    }
  );

  bar.hidden =
    found.others.length === 0;
}

var catalogWatcherStarted =
  false;

function watchSharedCatalog() {
  if (catalogWatcherStarted) {
    return;
  }

  var catalog =
    document.querySelector(
      '[data-klf-shared-catalog]'
    );

  if (
    !catalog ||
    typeof window.MutationObserver !== 'function'
  ) {
    return;
  }

  catalogWatcherStarted =
    true;

  var lastShown =
    '';

  function sync() {
    if (!catalog.classList.contains('is-open')) {
      lastShown =
        '';
      return;
    }

    var shown =
      clean(catalog.dataset.catalogAuthorProfileId);

    renderCatalogIdentities(catalog);

    /*
     * Switching names inside an open catalog starts the new list at the top.
     */
    if (
      lastShown &&
      shown !== lastShown
    ) {
      var dialog =
        catalog.querySelector(
          '.kinfolk-catalog__dialog'
        );

      if (dialog) {
        dialog.scrollTop =
          0;
      }
    }

    lastShown =
      shown;
  }

  new MutationObserver(sync)
    .observe(
      catalog,
      {
        attributes: true,
        attributeFilter: [
          'class',
          'data-catalog-author-profile-id'
        ]
      }
    );

  sync();
}

function initialize() {
  globalizeAll();
  watchSharedCatalog();

  /*
   * No Literary Interests are rendered.
   * Every Author track container begins empty and is populated from
   * canonical Book relationships when that identity is shown.
   */
  activeOpenAuthorProfileIds()
    .forEach(
      loadCanonicalTracksForProfile
    );
}

document.addEventListener(
  'shopify:section:load',
  initialize
);

if (
  document.readyState ===
  'loading'
) {
  document.addEventListener(
    'DOMContentLoaded',
    initialize,
    {
      once:true
    }
  );
} else {
  initialize();
}

})();
